import React from 'react';
import { makeStyles, createStyles, Grid } from '@material-ui/core';

import { PageLocation } from '../../../shared/enum/PageLocation';
import { HomeContext } from '../../Home/HomeContext';
import { VehicleModel, vehicleModelInitial } from '../../../Models/VehicleModel';
import { VehicleContext } from '../VehicleContext';
import { VehicleInput } from './VehicleInput';
import { VehicleSearch } from './VehicleSearch';

const useStyles = makeStyles(() => createStyles({
    gridContainer: {
        maxWidth: '1152px',
        margin: 0
    },
}));

export function Vehicle() {
    const classes = useStyles();

    const homeContext = React.useContext(HomeContext);

    const [vehicle, setVehicle] = React.useState<VehicleModel>(vehicleModelInitial);
    const [vehicleList, setVehicleList] = React.useState<VehicleModel[]>([]);

    return (
        <VehicleContext.Provider value={{
            vehicle, setVehicle,
            vehicleList, setVehicleList,
        }}>
            <Grid
                container
                justify="center"
                alignItems="center">
                <Grid
                    container
                    justify="center"
                    className={classes.gridContainer}
                    spacing={2}>
                    {homeContext.pageLocation === PageLocation.VEHICLE_INPUT && <VehicleInput />}
                    {homeContext.pageLocation === PageLocation.VEHICLE_EDIT && <VehicleInput />}
                    {homeContext.pageLocation === PageLocation.VEHICLE_SEARCH && <VehicleSearch />}
                </Grid>
            </Grid>
        </VehicleContext.Provider>
    );
}